import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader, Popup, Icon} from 'semantic-ui-react';

class Detail extends Component {
  renderBody() {
    const {detail} = this.props;

    return detail.map((order, index) => {
      return (
        <Table.Row key={index} error={!!order.error}>
          <Table.Cell verticalAlign='middle'>
            {this.renderErrorIcon(order)}
            {index + 1}
          </Table.Cell>
          <Table.Cell>{order.partCode}</Table.Cell>
          <Table.Cell>{order.partName}</Table.Cell>
          <Table.Cell textAlign='right'>{order.partQuantity}</Table.Cell>
          <Table.Cell textAlign='right'>{order.main}</Table.Cell>
          <Table.Cell textAlign='right'>{order.substitute}</Table.Cell>
          <Table.Cell textAlign='right'>{order.mainTransit}</Table.Cell>
          <Table.Cell textAlign='right'>{order.substituteTransit}</Table.Cell>
          <Table.Cell textAlign='right'>{order.canceled}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderErrorIcon(order) {
    if (!order.error) {
      return null;
    }
    
    return (
      <Popup flowing inverted
        content={order.error}
        trigger={<Icon color='red' size='large' className='warning sign' />}
      />
    );
  }

  render() {
    const {loading, verifying, detail} = this.props;

    if (loading || verifying) {
      return (
        <Card raised fluid>
          <Loader active inline='centered'>
            {loading ? 'Procesando pedido...' : 'Verificando pedido...'}
          </Loader>
        </Card>
      );
    }

    if (!detail.length) {
      return null;
    }

    return (
      <Card raised fluid className='dealer-stock-order-detail'>
        <div className='table-scroll'>
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Línea</Table.HeaderCell>
                <Table.HeaderCell>Código</Table.HeaderCell>
                <Table.HeaderCell>Parte</Table.HeaderCell>
                <Table.HeaderCell>Pedido</Table.HeaderCell>
                <Table.HeaderCell>Despachar Principal</Table.HeaderCell>
                <Table.HeaderCell>Despachar Sustituto</Table.HeaderCell>
                <Table.HeaderCell>Tránsito Principal</Table.HeaderCell>
                <Table.HeaderCell>Tránsito Sustituto</Table.HeaderCell>
                <Table.HeaderCell>Cancelado</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.renderBody()}
            </Table.Body>
          </Table>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'verifying': state.dealerStockOrders.verifying,
    'loading': state.dealerStockOrders.loading,
    'detail': state.dealerStockOrders.list,
  };
};

export default connect(mapStateToProps)(Detail);
